$('#certificate_authenticity_form').submit(function(event){
  event.preventDefault();

  var number = $('#certificate_number').val(),
      url = '/apps/certificates/' + number + '.json',
      el = $('#certificate_details');

  el.hide();

  $('#certificate_authenticity_loading').show();
  $('#invalid_certification_number').hide();

  $.getJSON(url, function(c) {
    if(c == null) {
      $('#certificate_details').hide();
      $('#invalid_certification_number').show();
    } else {
      if(c.additional_info) {
        c.additional_info = c.additional_info.replace(/\n/g, "<br/>");

        $('.additional_info td', el).html(c.additional_info);
        $('.additional_info', el).show();
      } else {
        $('.additional_info td', el).html('');
        $('.additional_info', el).hide();
      }

      $('.number', el).text(c.number);
      $('.athlete', el).text(c.athlete);
      $('.item', el).text(c.item);
      $('.event', el).text(c.event);

      $('.image', el).attr('src', c.image_url);

      el.show();
      $('#invalid_certification_number').hide();
    }

    $('#certificate_authenticity_loading').hide();
  });
});

$('#certificate_authenticity_loading').hide();
$('#certificate_authenticity_form').show();
